import {ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef} from '@angular/core';
import {SelectionOperationsService} from 'app/selection-operations.service';
import {FragmentService} from '../../services/fragment.service';
import {MemoFragment} from '../types';
import {TextFragmentComponent} from './text-fragment.component';

@Component({
  selector: 'cars-memo-fragment',
  template: `<span class="memo">{{ content.value }}</span
    ><span *ngIf="showZeroWidthSpaceAfterText()">&ZeroWidthSpace;</span>`,
  styleUrls: ['../core/fragment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MemoFragmentComponent extends TextFragmentComponent {
  public set content(value: MemoFragment) {
    super.content = value;
  }

  public get content(): MemoFragment {
    return super.content;
  }

  constructor(
    protected _fragmentService: FragmentService,
    protected _selectionOperationsService: SelectionOperationsService,
    protected _cd: ChangeDetectorRef,
    _elementRef: ElementRef
  ) {
    super(_fragmentService, _selectionOperationsService, _cd, _elementRef);
  }

  public showZeroWidthSpaceAfterText(): boolean {
    return TextFragmentComponent.showZeroWidthSpaceAfterFragment(this.content);
  }
}
